import React, { useState, useEffect } from 'react'
import { Item } from '../../../common/snippets'
import { Box, Button } from '@mui/material'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import DropDownOA from '../../../common/dropDownOA'
import { connect, useDispatch } from 'react-redux'
import { GetRechargePaymentModesListAll, updateAlertError, updateModal } from '../../../../store/common/common_action'
import * as id from '../reportId'
import moment from 'moment'
import { getBranchRechargeListAll, GetBranchRechargeListAllData } from '../../../common/jotaiState/dispatchRegisterReport'
import { focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../common/helper'
import Datepicker from '../../../common/datePicker'
import { columnDefs, excelHeaderColumn } from './constant'
import { useAtom, useSetAtom } from 'jotai'
import { globalLoaderAtom, alertAtom } from '../../../common/jotaiState/globalStateAtoms'
import { urls } from '../../../common/constants'
import { GetRequest, PostRequest } from '../../../common/api'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../../helpers/useTokens'
import { CargoRoleRightsAtom } from '../../../common/jotaiState/commonStateAtoms'
import { downloadPDF } from '../../Reports/analysisReport/pdfAutotable'

const reportName = 'Branch Recharge Report'

const BranchRechargeReportNew = (props) => {
    const { data: { common }, } = props
    const { RechargePaymentList } = common

    const dispatch = useDispatch()
    const setLoader = useSetAtom(globalLoaderAtom)
    const setAlert = useSetAtom(alertAtom)

    const [fromDate, setFromDate] = useState(moment(new Date()))
    const [toDate, setToDate] = useState(moment(new Date()))
    const [resBranchCity, setResBranchCity] = useState([])
    const [sourceCityList, setSourceCityList] = useState([])
    const [sourceBranchList, setSourceBranchList] = useState([])
    const [selSourceCity, setSelSourceCity] = useState([])
    const [selSourceBranch, setSelSourceBranch] = useState()
    const [paymentModeList, setPaymentModeList] = useState([])
    const [selPaymentMode, setSelPaymentMode] = useState()

    const [branchRechargeList] = useAtom(GetBranchRechargeListAllData)
    const [showTable, setShowTable] = useState(false)
    const [tableData, setTableData] = useState([])

    const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
    const { Table1: RoleRightTable1 = [] } = cargoRoleRights
    const [roleRightsData] = RoleRightTable1
    let { AllowViewAllBranchOfCityReport, AllowViewAllBranchReport, AllowBranchInchargeRights } = { ...roleRightsData }    
    const [searchParams] = useSearchParams()

    let { loginData = {} } = useToken()
    let isFromUrl = false
    if (!loginData) {
        loginData = {}
        loginData.intCompanyID = +searchParams.get('C') || 0
        loginData.intBranchCityID = +searchParams.get('CT') || 0
        loginData.intUserID = +searchParams.get('U') || 0
        loginData.intBranchID = +searchParams.get('B') || 0
        loginData.strUserName = searchParams.get('UN') || ''
        loginData.strCompanyName = searchParams.get('CN') || ''
        loginData.strBranchName = searchParams.get('BN') || ''
        AllowViewAllBranchOfCityReport = +searchParams.get('AllowViewAllBranchOfCityReport') || 0
        AllowViewAllBranchReport = +searchParams.get('AllowViewAllBranchReport') || 0
        AllowBranchInchargeRights = +searchParams.get('AllowBranchInchargeRights') || 0
        isFromUrl = true
    }
    
    const { intCompanyID, IsAdmin, intUserID,intCityID, intBranchID, intBranchCityID, strCompanyName, IsBranchAdmin, IsMTPLAdmin } = loginData

    useEffect(() => { focusElemnt('fromRechargeDate') }, [])

    useEffect(() => {
        if (resBranchCity?.length > 0) {
            const branches = resBranchCity?.map((record) => ({
                BranchID: record.BranchID,
                BranchName: record.BranchName,
                CityID: record.CityID,
                CityName: record.CityName,
            }))
            const cities = resBranchCity?.map((record) => ({
                CityID: record.CityID,
                CityName: record.CityName,
            }))
            const cityList = removeDuplicatesFromArray(cities, 'CityID')
            const branchList = removeDuplicatesFromArray(branches, 'BranchID')
            setSourceCityList([{ CityName: 'All', CityID: 0 }, ...cityList])
            setSourceBranchList([{ BranchName: 'All', BranchID: 0 }, ...branchList])
        }
    }, [resBranchCity])

    useEffect(() => {
        if (sourceCityList?.length > 0) {
            if (AllowViewAllBranchOfCityReport === 0 && AllowViewAllBranchReport === 0) {
                const loginCity = sourceCityList.find((val) => val?.CityID === intBranchCityID);
                setSelSourceCity(loginCity || sourceCityList[0]);
            } else if (AllowViewAllBranchOfCityReport === 1 && AllowViewAllBranchReport === 0) {
                const loginCity = sourceCityList.find((val) => val?.CityID === intBranchCityID);
                setSelSourceCity(loginCity || sourceCityList[0]);
            } else {
                setSelSourceCity(sourceCityList[0]);
            }
        }
    }, [sourceCityList, AllowViewAllBranchOfCityReport, AllowViewAllBranchReport]);

    useEffect(() => {
        if (sourceBranchList?.length > 0) {
            if (AllowViewAllBranchReport === 0 && AllowViewAllBranchOfCityReport === 0) {
                const loginBranch = sourceBranchList.find((val) => val?.BranchID === intBranchID);
                setSelSourceBranch(loginBranch || sourceBranchList[0]);
            } else {
                setSelSourceBranch(sourceBranchList[0]);
            }
        }
    }, [sourceBranchList, AllowViewAllBranchReport, AllowViewAllBranchOfCityReport]);

    useEffect(() => {
        if (!isEmpty(roleRightsData)) {
            if (AllowViewAllBranchReport || IsBranchAdmin || IsMTPLAdmin || IsAdmin) {
                const obj = {
                    intUserID: 0,
                    intCompanyID: intCompanyID,
                    intBranchID: 0,
                    strBranchName: '',
                    strBranchCode: '',
                    intStateID: 0,
                    intCityID: 0,
                    intIsActive: -1,
                }
                PostRequest(urls.getBranchConfigOrEwbillinfo, obj).then((res) => {
                    if (res.status === 'Success') {
                        setResBranchCity(res?.Data?.Table)
                    }
                })
            } else if (!AllowViewAllBranchOfCityReport && AllowBranchInchargeRights) {
                const obj = {
                    CompanyID: intCompanyID,
                    CityID: intCityID,
                    UserID: intUserID,
                    BranchID: intBranchID,
                    Mode: 1,
                }
                GetRequest(urls.getReportBranchList, obj).then((res) => {
                    if (res.status === 'Success') {
                        setResBranchCity(res?.Data?.Table)
                    }
                })
            } else {
                const obj = {
                    intUserID: 0,
                    intCompanyID: intCompanyID,
                    intBranchID: 0,
                    strBranchName: '',
                    strBranchCode: '',
                    intStateID: 0,
                    intCityID: intCityID,
                    intIsActive: -1,
                }
                PostRequest(urls.getBranchConfigOrEwbillinfo, obj).then((res) => {
                    if (res.status === 'Success') {
                        setResBranchCity(res?.Data?.Table)
                    }
                })
            }
            dispatch(GetRechargePaymentModesListAll())
        }
    }, [roleRightsData, dispatch])

    useEffect(() => {
        setTableData(branchRechargeList)
    }, [branchRechargeList])

    useEffect(() => {
        if (sourceCityList?.length > 0) {
            const loginCity = sourceCityList?.find((val) => val?.CityID === intBranchCityID)
            if (loginCity) {
                setSelSourceCity(loginCity)
            } else {
                setSelSourceCity(sourceCityList[0])
            }
        }
    }, [sourceCityList])

    useEffect(() => {
        if (sourceBranchList?.length > 0) {
            const loginBranch = sourceBranchList?.find((val) => val?.BranchID === intBranchID)
            if (loginBranch) {
                setSelSourceBranch(loginBranch)
            } else {
                setSelSourceBranch(sourceBranchList[0])
            }
        }
    }, [sourceBranchList])

    useEffect(() => {
        if (RechargePaymentList?.length > 0) {
            const list = [
                { RechargePaymentModeName: 'All', RechargePaymentModeID: 0 },
                ...RechargePaymentList,
                { RechargePaymentModeName: 'UPI-QR', RechargePaymentModeID: 7 },
            ]
            setPaymentModeList(list)
            setSelPaymentMode(list[0])
        }
    }, [RechargePaymentList])

    const getMainHeader = (columns = []) =>
        columns.map(col => {
            const header = col.headerName || col.header || ''
            return {
                ...col,
                header,
                exportHead: col.exportHead || header,
                align: col.align || (col?.xlCol?.dataType === 'string' ? 'left' : 'right'),
                weight: col?.weight ?? 80,
            }
        })

    const criteriaHeaders = excelHeaderColumn.map(col => ({
        field: col.field,
        header: col.headerName,
        textAlign: col.align || 'left',
    }))

    const criteriaData = [{
        fromDate: fromDate.format('DD-MMM-YYYY'),
        toDate: toDate.format('DD-MMM-YYYY'),
        branchCity: selSourceCity?.CityName || '',
        branchName: selSourceBranch?.BranchName || '',
        rechargeMode: selPaymentMode?.RechargePaymentModeName || '',
        dataType: 'entry',
    }]

    const handleLoad = async (isPdf = false) => {
        setLoader(true)
        const obj = {
            CompanyID: intCompanyID,
            BranchID: selSourceBranch?.BranchID,
            frmDate: fromDate.format('YYYY-MM-DD'),
            ToDate: toDate.format('YYYY-MM-DD'),
            RechargeMode: selPaymentMode?.RechargePaymentModeID,
            CityID: selSourceCity?.CityID,
            UserID: intUserID,
            AllowViewAllReport: 1,
        }
        const res = await GetRequest(urls.getBranchRechargeListAll + '?', obj)
        setLoader(false)

        if (res?.status !== 'Success' || !res?.Data?.Table?.length) {
            setAlert({ show: true, msg: 'No data found' })
            return
        }

        const tableData = res.Data.Table.map((val, i) => ({
            ...val,
            SN: i + 1,
            dataType: 'entry',
            transactionDateTime: val.transactionDateTime
                ? moment(val.transactionDateTime).format('DD/MM/YYYY HH:mm:ss')
                : '',
            AcceptedOrRejectedDateTime: val.AcceptedOrRejectedDateTime
                ? moment(val.AcceptedOrRejectedDateTime).format('DD/MM/YYYY HH:mm:ss')
                : '',
        }))
        const reportPayload = {
            reportName,
            criteriaHeaders,
            criteriaData,
            mainHeader: getMainHeader(columnDefs),
            tableData,
            serialNokey: 'SN',
        }
        if (isPdf === true) {
            downloadPDF({
                reportName,
                criteriaHeaders,
                criteriaData,
                tableData,
                visibleColumns: getMainHeader(columnDefs),
                loginData,
                hideHeader: false
            })
            return
        }
        const rid = Date.now().toString()
        if (!window.generatedReports) window.generatedReports = {}
        window.generatedReports[rid] = reportPayload
        window.open(`/view-report?rid=${rid}`, '_blank')
    }

    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', marginTop: '10px', padding: '0 24px' }}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: isFromUrl ? '15px' : '10px' }} className="itemButtons">                    
                    {!isFromUrl && <Item sx={sx.itemsxGrow}>
                        <DropDownOA
                            id={id.selectCompnay}
                            label={'Company Name'}
                            defaultvalue={strCompanyName}
                            disabled={true}
                            onSelect={(val) => {
                                setShowTable(false)
                            }}
                            width="100%"
                        />
                    </Item>}
                    <Item sx={sx.itemsxGrow} style={{ width: !isFromUrl ? '140px' : 'auto' }} className="input--container bookingDatePicker">
                        <Datepicker
                            name={'from_collection_date'}
                            value={fromDate}
                            label={'From Recharge Date'}
                            id={'fromRechargeDate'}
                            dateChange={(date) => {
                                setFromDate(date)
                                setShowTable(false)
                                focusElemnt('toRechargeDate')
                            }}
                            width="100%"
                        />
                    </Item>
                    <Item sx={sx.itemsxGrow} style={{ width: !isFromUrl ? '140px' : 'auto' }} className="input--container bookingDatePicker">
                        <Datepicker
                            id={'toRechargeDate'}
                            label={'To Recharge Date'}
                            value={toDate}
                            dateChange={(date) => {
                                setToDate(date)
                                setShowTable(false)
                                focusElemnt('branchCity')
                            }}
                            width="100%"
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                        <DropDownOA
                            id={'branchCity'}
                            label={'Branch City'}
                            data={sourceCityList}
                            defaultvalue={selSourceCity?.CityName}
                            idKey={`CityID`}
                            dataKey={`CityName`}                            
                            minWidth={isFromUrl ? '100%' : '200px'}
                            nextId={'branchName'}
                            prevId={`toRechargeDate`}
                            disabled={AllowViewAllBranchReport === 0}
                            onSelect={(obj) => {
                                setSelSourceCity(obj)
                                setShowTable(false)
                                setSelSourceBranch(
                                    removeDuplicatesFromArray(sourceBranchList, 'BranchID').filter(
                                        (val) => val.CityID === obj?.CityID || obj?.CityID === 0 || val.BranchID === 0
                                    )?.[0]
                                )
                            }}
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                        <DropDownOA
                            id={'branchName'}
                            label={'Branch Name'}
                            data={
                                removeDuplicatesFromArray(sourceBranchList, 'BranchID').filter(
                                    (val) => val.CityID === selSourceCity?.CityID || selSourceCity?.CityID === 0 || val.BranchID === 0
                                ) || []
                            }
                            idKey={`BranchID`}
                            dataKey={`BranchName`}
                            defaultvalue={selSourceBranch?.BranchName}
                            disabled={AllowViewAllBranchReport === 0 && AllowViewAllBranchOfCityReport === 0}
                            minWidth={isFromUrl ? '100%' : '262px'}
                            nextId={'reachargeMode'}
                            prevId={`branchCity`}
                            onSelect={(val) => {
                                setSelSourceBranch(val)
                                setShowTable(false)
                            }}
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                        <DropDownOA
                            id={'reachargeMode'}
                            label={'Recharge Mode'}
                            defaultvalue={selPaymentMode?.RechargePaymentModeName}
                            value={selPaymentMode?.RechargePaymentModeName}
                            data={paymentModeList || []}
                            idKey={`RechargePaymentModeID`}
                            dataKey={`RechargePaymentModeName`}
                            minWidth={isFromUrl ? '100%' : '200px'}
                            nextId={'load_btn'}
                            prevId={`branchName`}
                            onSelect={(val) => {
                                setSelPaymentMode(val)
                                setShowTable(false)
                            }}
                        />
                    </Item>
                    {isFromUrl ?
                        <Button variant="contained" sx={{ width: '100%', height: '40px' }} className="btn btn-primary" onClick={() => handleLoad(true)} id={'load_btn'}>
                            DOWNLOAD PDF
                        </Button> :
                        <Item sx={{ ...sx.itemsx }} className="disabled-wrapper">
                            <Button
                                variant="contained"
                                id={'load_btn'}
                                sx={{ paddingY: '7px !important', height: '40px' }}
                                className="btn btn-primary"
                                onClick={handleLoad}
                                onKeyDown={(e) => navigation3(e, 'fromRechargeDate', 'reachargeMode', () => { })}
                            >
                                Load
                            </Button>
                        </Item>}
                </Box>
            </Box>
        </>
    )
}

const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal, updateAlertError }
export default connect(mapStateToProps, mapDispatchToProps)(BranchRechargeReportNew)
